export const m2c2kitCss = `.m2c2kit-background-color {
  background: white;
}

.m2c2kit-no-margin {
  margin: 0;
}

.m2c2kit-display-none {
  display: none;
}

.m2c2kit-display-block {
  display: block;
}

.m2c2kit-full-viewport {
  height: 100vh;
  width: 100vw;
}

.m2c2kit-flex-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.m2c2kit-canvas-overlay {
  background-color: white;
  width: 100vw;
  height: 100vh;
  position: absolute
}

.m2c2kit-spinner {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #212529;
  width: 120px;
  height: 120px;
  /* Safari */
  -webkit-animation: m2c2kit-loader-spin 1.5s linear infinite;
  animation: m2c2kit-loader-spin 1.5s linear infinite;
  position: absolute;
}

#m2c2kit-time-stepping-div {
  position: fixed;
  top: 4px;
  left: 4px
}

/* Safari */
@-webkit-keyframes m2c2kit-loader-spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes m2c2kit-loader-spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}`;
